"use client";

import { motion, AnimatePresence } from "framer-motion";
import { MessageSquare, Phone } from "lucide-react";

type SidebarState =
  | "expanded"
  | "collapsed"
  | "transition-opening"
  | "transition-closing";

interface CommunicationSectionProps {
  sidebarState: SidebarState;
  onFeedbackClick: () => void;
  onDoctorCallClick: () => void;
}

export function CommunicationSection({
  sidebarState,
  onFeedbackClick,
  onDoctorCallClick,
}: CommunicationSectionProps) {
  // Determine when to show communication section
  const showCommunication =
    sidebarState === "expanded" || sidebarState === "transition-opening";

  // Different animation timings for opening vs closing
  const animationDelay = sidebarState === "transition-opening" ? 0.15 : 0;
  const animationDuration = sidebarState === "transition-closing" ? 0 : 0.15;

  return (
    <AnimatePresence>
      {showCommunication && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, transition: { duration: animationDuration } }}
          transition={{ duration: 0.15, delay: animationDelay }}
          className="px-4 py-4"
        >
          <div className="space-y-3">
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3">
              Kommunikation
            </h3>
            <div className="space-y-1">
              <button
                onClick={onFeedbackClick}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-900 hover:bg-white/50 rounded-lg transition-colors"
              >
                <MessageSquare className="h-4 w-4" />
                <span>Feedback senden</span>
              </button>
              <button
                onClick={onDoctorCallClick}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-900 hover:bg-white/50 rounded-lg transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>Info vom Arzt</span>
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
